"use client"

import { useState } from "react"
import DisciplinaForm from "../components/Disciplinas/DisciplinaForm"
import DisciplinaList from "../components/Disciplinas/DisciplinaList"
import "../styles/DisciplinaPage.css"

export default function DisciplinasPage() {
  const [updateList, setUpdateList] = useState(false)
  const [disciplinaParaEditar, setDisciplinaParaEditar] = useState(null)

  const handleAdded = () => {
    setUpdateList((prev) => !prev)
    setDisciplinaParaEditar(null)
  }

  const handleEdit = (disciplina) => {
    setDisciplinaParaEditar(disciplina)
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const handleCancelEdit = () => {
    setDisciplinaParaEditar(null)
  }

  return (
    <div className="disciplinas-page">
      <h1 className="page-title">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
        </svg>
        Gestão de Disciplinas
      </h1>

      <DisciplinaForm
        onAdded={handleAdded}
        disciplinaParaEditar={disciplinaParaEditar}
        onCancelEdit={handleCancelEdit}
      />

      <DisciplinaList keyProp={updateList} onEdit={handleEdit} />
    </div>
  )
}
